import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '../../components/ui/dropdown-menu';
import { X, Clock, CheckCircle2, Lock, AlertCircle, Home, ChevronDown } from 'lucide-react';

export const BulkActionBar = ({ selectedCount, onClear, onStatusAction, onOccupancyAction, userRole, isReadOnly }) => {
  if (selectedCount === 0 || isReadOnly) return null;

  const isAdmin = userRole === 'admin' || userRole === 'management';

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-background border-2 border-primary/20 rounded-xl shadow-2xl px-5 py-3 flex items-center gap-4 animate-in slide-in-from-bottom-4"
      data-testid="bulk-action-bar"
    >
      <Badge variant="secondary" className="text-sm font-semibold px-3 py-1">
        {selectedCount} selected
      </Badge>

      {/* Sales Status Actions */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" data-testid="bulk-status-menu">
            Change Status <ChevronDown className="w-3 h-3 ml-1" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center">
          <DropdownMenuLabel className="text-xs">Sales Status</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => onStatusAction('available')} data-testid="bulk-release-btn">
            <X className="w-4 h-4 mr-2 text-emerald-600" /> Release (Available)
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onStatusAction('soft_blocked')} data-testid="bulk-block-btn">
            <Clock className="w-4 h-4 mr-2 text-amber-600" /> Soft Block
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onStatusAction('booked')} data-testid="bulk-book-btn">
            <CheckCircle2 className="w-4 h-4 mr-2 text-rose-600" /> Book
          </DropdownMenuItem>
          {isAdmin && (
            <>
              <DropdownMenuItem onClick={() => onStatusAction('sold')} data-testid="bulk-sold-btn">
                <Lock className="w-4 h-4 mr-2 text-blue-600" /> Mark Sold
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onStatusAction('on_hold')} data-testid="bulk-hold-btn">
                <AlertCircle className="w-4 h-4 mr-2 text-slate-600" /> On Hold
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Occupancy Status Actions */}
      <Button variant="outline" size="sm" onClick={onOccupancyAction} data-testid="bulk-occupancy-btn">
        <Home className="w-4 h-4 mr-1" /> Occupancy
      </Button>

      <Button variant="ghost" size="sm" onClick={onClear} data-testid="bulk-clear-btn">
        <X className="w-4 h-4 mr-1" /> Clear
      </Button>
    </div>
  );
};
